import { NgModule } from "@angular/core";
import { LocalizedDatePipe } from "./localizedDatePipe";

@NgModule({
    declarations: [LocalizedDatePipe],
    exports: [LocalizedDatePipe]
})
export class LocalizedDatePipeMoule {}